module.exports = "/assets/data/5182f3b1f0928f0282e18e837b65ac47-BN6.data.json";